import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import Moment from "react-moment";
import PropTypes from "prop-types";
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import Avatar from "@material-ui/core/Avatar";
import ContractDetails from "./ContractDetails";
import { BreadcrumbPage } from "../../shared";
import clsx from "clsx";
import { Button, Grid } from "@material-ui/core";
import { getCookie } from "../../services/Cookies";
import { postRequest } from "../../services/ApiServices";
import { ToastError } from "../../services/ToastMsg";
import { LOADING } from "../../action";
import { useDispatch } from "react-redux";
import { getCurrentDate, getCurrentDateOfBelow } from "../../services/DateServices";
 import {
  KeyboardDatePicker,
  DatePicker
} from "@material-ui/pickers";

import {
  FormHelperText,
  Input,
  Radio,
  RadioGroup,
  InputLabel,
  InputBase,
  FormControlLabel,
} from "@material-ui/core";
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },

  
}))(TableCell);


 

const useStyles = makeStyles((theme) => ({
 
  boxLayout: {
    backgroundColor: "#fff",
    boxShadow: "1px 1px 4px 1px #e0e0e0",
    borderRadius: 8,
  },
  TableTheme: {
    fontSize: "20px",
  },
  tableLayout: {
    border: 0,
    boxShadow: "0 0 0 0 !important",
  },
  active: {
    backgroundColor: "#F5F5F4",
  },
  table: {
    minWidth: 650,
  },
  root: {
    display: "flex",
  },
  input1: {
    height: 50,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },

  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },

  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  content: {
    flexGrow: 1,
    padding: "0 25px",

    marginTop: "0 !important",
  },
  listheight: {
    height: "85vh",
    overflow: "auto",
  },
  liselected: {
    background: "#ff4717",
  },
  large: {
    width: theme.spacing(12),
    height: theme.spacing(12),
  },
  radioInput: {
    padding: 0,
    "&.Mui-checked": {
      color: "#ff4717",
    },
  },
  
  btnStyle2: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
    marginRight:"8px"
  },
}));

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const tableClasses = useRowStyles();
  const classes = useStyles();

  return (
    <React.Fragment>
      <TableRow
        className={clsx(
          tableClasses.root,
          open ? classes.active : classes.inactive
        )}
      >
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.customerName}
        </TableCell>
        <TableCell>{row.axContractId}</TableCell>
        <TableCell>
          {" "}
          <Moment format="DD/MM/YYYY">{row.billingStartDate}</Moment> -{" "}
          <Moment format="DD/MM/YYYY">{row.bIllingEndDate}</Moment>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ padding: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box>
              {/* <Typography variant="h6" gutterBottom component="div">
                {row.contractNumber}
              </Typography> */}
              <ContractDetails row={row} />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}


const Contracts = (props) => {
  const classes = useStyles();
  const [contractDetails, setContractDetails] = React.useState([]);
  const BreadcrumbList = [{ name: "Contracts", url: "" }];
  const dispatch = useDispatch();
  const formObjFormat  = {
    customerKeys : getCookie("clientId"),
    startDate : "",
    endDate :  "",
    status : ""
  }
  const [formObj, setFormObj]=useState(formObjFormat);

  useEffect(() => {
    getContracts({customerKeys:getCookie("clientId")});
  }, []);

  const getContracts = (data) => {
    dispatch({ type: LOADING, payload: true });
    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      `Contract`;
    postRequest(url, data)
      .then((res) => {
        ////console.log(res);
        if (res.status == 200) {
          dispatch({ type: LOADING, payload: false });
          setContractDetails(res.data);
        } else {
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        setContractDetails([]);
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
        // ToastError(error.response.data.message);
      });
  };
  
  const getContractsFilter = (formObjData) => {
    dispatch({ type: LOADING, payload: true });
    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      `Contract`;
      let data  = {};
      if(formObjData.startDate){  data = {...data, startDate: formObjData.startDate}}
      if(formObjData.endDate){  data = {...data, endDate: formObjData.endDate}}
      if(formObjData.status){  data = {...data, status: formObjData.status}}
      if(formObjData.customerKeys){  data = {...data, customerKeys: formObjData.customerKeys}}

    postRequest(url, data)
      .then((res) => {
        ////console.log(res);
        if (res.status == 200) {
          dispatch({ type: LOADING, payload: false });
          setContractDetails(res.data);
        } else {
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        setContractDetails([]);
        dispatch({ type: LOADING, payload: false });
        ////console.log(error);
        // ToastError(error.response.data.message);
      });
  };
  
  const onChangeText = (event) => {
    let obj = { ...formObj, [event.target.name]: event.target.value } 
    setFormObj(obj);
    getContractsFilter(obj);
  };
  const onChangeStartDate = (event) => {
    let startDate = "";
    if(event){
      startDate = event.format('YYYY-MM-DD');
    }
    let obj = { ...formObj, startDate: startDate } ;
    setFormObj(obj);
    getContractsFilter(obj);
  };
  
  const onChangeEndDate = (event) => {
    let endDate = "";
    if(event){
      endDate = event.format('YYYY-MM-DD');
    }
    let obj = { ...formObj, endDate: endDate } ;
    setFormObj(obj);
    getContractsFilter(obj);
  };
  const onClearObj = () => {
    setFormObj(formObjFormat);
    getContracts({customerKeys:getCookie("clientId")});
  }

  ////console.log(formObj);
  return (
    <div>
      <Box component="main" className={classes.content + " rightbar"}>
        <Box pb={3} pt={0} display="dlock">
          <BreadcrumbPage rows={BreadcrumbList} />
        </Box>
        <Box pb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12}>
              <Box p={2} height={1} className={classes.boxLayout}>
                  <Box
                      component="h2"
                      m={0}
                      className="blcopy"
                      fontWeight="500"
                      pb={2}
                    >
                      Filters:
                    </Box>
                <Grid container spacing={5}>
                  <Grid item  >
                   <Box display="flex">
                      <Box>
                        <Box
                          component="span"
                          className="blcopy"
                          mr={2}
                          fontSize="18px"
                        >
                          Contract date
                        </Box>
                        <Box component="span" mr={2}>
                          <KeyboardDatePicker className="date-input"
                            name ="startDate"
                            invalidDateMessage="" 
                            value={formObj.startDate}
                            format="DD/MM/yyyy" 
                            placeholder="From"
                            onChange={onChangeStartDate}
                            InputLabelProps={{
                              shrink: true,
                              disableUnderline: true,
                            }}
                        
                            id="outlined-basic"  variant="outlined"
                            
                          />
                        </Box>
                        <Box component="span" mr={2}>
                          <KeyboardDatePicker className="date-input"
                            name ="endDate"
                            invalidDateMessage="" 
                            value={formObj.endDate}
                            format="DD/MM/yyyy"
                            placeholder="To"
                            onChange={onChangeEndDate}
                            InputLabelProps={{
                              shrink: true,
                              disableUnderline: true,
                            }}
                            id="outlined-basic"  variant="outlined"
                            
                          />
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item  >
                    <Box display="flex">
                      <Box>
                        <RadioGroup
                          row
                          aria-label="position"
                          name="status"
                          defaultValue="top"
                          value={formObj.status}
                          onChange={onChangeText}
                        >
                          <Box
                            component="span"
                            mr={2}
                            fontSize="18px"
                            className="blcopy"
                          >
                            Status 
                          </Box>
                          <Box
                            component="span"
                            fontSize="18px"
                            className="blcopy"
                          >
                          <FormControlLabel
                            value="Active"
                            control={<Radio className={classes.radioInput} />}
                            // label="Active"
                            labelPlacement="start"
                          /><Box
                          component="span"
                          ml={1}
                          fontSize="18px"
                          className="blcopy"
                        > Active</Box>
                            </Box>
                          <Box
                            component="span" 
                            fontSize="18px"
                            className="blcopy"
                          >
                          <FormControlLabel
                            value="Inactive"
                            control={<Radio className={classes.radioInput} />}
                            // label="InActive"
                            labelPlacement="start"
                          /> <Box
                          component="span"
                          ml={1}
                          fontSize="18px"
                          className="blcopy"
                        >Inactive</Box>
                          </Box>
                        </RadioGroup>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12} md={2}>
                  <Button type="submit" onClick={onClearObj} className={classes.btnStyle2}>
                    Clear
                  </Button>
                    </Grid>
                </Grid>
              </Box>
            </Grid>
            {/* <Grid item xs={12} sm={12} md={4}>
              <Box p={2} className={classes.boxLayout}>
                <Box component="h2" m={0} fontWeight="500" pb={1}>
                  Export
                </Box>
                <Box display="flex" flexWrap="wrap">
                  <Box  className="export-icon" >
                  <img src="/assets/svg/pdf.svg" />PDF
                  </Box>
                  <Box  className="export-icon">
                  <img src="/assets/svg/xls.svg" />MS Excel
                  </Box>
                  <Box  className="export-icon" >
                  <img src="/assets/svg/printer.svg" />Print
                  </Box>
                </Box>
              </Box>
            </Grid> */}
          </Grid>
        </Box>
        <Box className={classes.boxLayout}>
          <Box className={classes.root}>
            <TableContainer
              component={Paper}
              className={clsx(classes.TableTheme)}
            >
              <Table
                aria-label="collapsible table"
                className={classes.tableLayout}
              >
                <TableHead>
                  <TableRow>
                    <StyledTableCell className="bl-bg" />
                    <StyledTableCell className="bl-bg">
                      Customer Contract
                    </StyledTableCell>
                    <StyledTableCell className="bl-bg">
                   VPS Contract Number
                    </StyledTableCell>
                    <StyledTableCell className="bl-bg">
                      Contract Duration{" "}
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="cc-tble">
                  {contractDetails.length
                    ? contractDetails.map((row) => (
                        <Row key={row.contractKey} row={row} />
                      ))
                    : (<TableCell colSpan="4">
                      <Box textAlign="center" m={2}>No Record Found</Box>
                      </TableCell>)}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      </Box>
    </div>
  );
};
export default Contracts;
